// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"YellowBox-module__wrapper___ALkEf","newWrapper":"YellowBox-module__newWrapper___fQ81d","wrapperShadow":"YellowBox-module__wrapperShadow___KY3KT"};